import * as RA from '../fp-ts/ReadonlyArray';
import * as RNEA from '../fp-ts/ReadonlyNonEmptyArray';
import * as RR from '../fp-ts/ReadonlyRecord';
import { pipe } from '../fp-ts/function';
import * as s from '../fp-ts/string';
import { isExact } from './exact';
import { isIntersection } from './intersection';
import { isOptionFromNullable } from './optionFromNullable';
import { isOptionFromUndefined } from './optionFromUndefined';
import { isReadonlyArray } from './readonlyArray';
import { isReadonlyNonEmptyArray } from './readonlyNonEmptyArray';
import { isType } from './type';
import { isUnion } from './union';
var getFieldsFromType = function (codec) {
    return pipe(codec.props, RR.collect(s.Ord)(function (key, codec) {
        return pipe(codec, getFields, RA.match(function () { return RNEA.of(key); }, RNEA.map(s.prepend("".concat(key, ".")))));
    }), RA.flatten, RA.uniq(s.Eq));
};
/**
 * Extract all end paths of a record-like strucure. No intermediate paths are
 * generated.
 *
 * @example
 * ```ts
 * const codec = t.type({
 *   a: t.number,
 *   b: t.type({
 *     c: t.string
 *   })
 * })
 *
 * const fields = getFields(codec)
 * // => ['a', 'b.c']
 * ```
 */
export var getFields = function (codec) {
    if (isType(codec))
        return getFieldsFromType(codec);
    if (isExact(codec))
        return getFields(codec.type);
    if (isIntersection(codec))
        return pipe(codec.types, RA.chain(getFields));
    if (isUnion(codec))
        return pipe(codec.types, RA.chain(getFields));
    if (isReadonlyArray(codec))
        return getFields(codec.type);
    if (isReadonlyNonEmptyArray(codec))
        return getFields(codec.type);
    if (isOptionFromNullable(codec))
        return getFields(codec.type);
    if (isOptionFromUndefined(codec))
        return getFields(codec.type);
    return RA.empty;
};
